import { withStyles } from "@material-ui/core/styles";
import MuiEditIcon from "@material-ui/icons/Edit";

const EditIcon = withStyles(theme => ({
  root: {
    color: theme.palette.grey[500],
    cursor: "pointer",
    fontSize: props => (props.fontSize === "small" ? 12 : 16),
    marginLeft: theme.spacing(1),
    "&:hover": {
      color: theme.palette.grey[700]
    }
  }
}))(MuiEditIcon);

export default EditIcon;
